import { useMemo } from 'react';

import { farmWorkOrdersService } from '../../../../services/farmWorkOrdersService';
import { createApiSlice } from '../../utils/createApiSlice';

const addFarmWorkOrderNoteSlice = createApiSlice({
  reducerPath: ['newGrowths', 'farmWorkOrders', 'addFarmWorkOrderNote'],
  apiFunction: farmWorkOrdersService.addFarmWorkOrderNoteV2,
  apiArgumentsFn: ({ growerId, seasonId, farmId, workOrderId, data }) => [
    growerId,
    seasonId,
    farmId,
    workOrderId,
    data
  ]
});

const { actions, useApiSelectors } = addFarmWorkOrderNoteSlice;

export const addFarmWorkOrderNoteActions = actions;

export const useAddFarmWorkOrderNoteSelectors = () => {
  const { inProgress, errorMessage, success, updatedAt } = useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, success, updatedAt]
  );
};

export default addFarmWorkOrderNoteSlice;
